import React, { FC } from 'react';
import useMiniCard from 'hooks/useMiniCard';
import PriorityIcon from 'generic/MiniCard2/components/PriorityIcon';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import AdvertItemDataModel from 'models/AdvertDataModel/AdvertItemDataModel';
import { NameStyles, NameLink, NameOfType } from './NameStyles';

interface Props {
  item: AdvertItemDataModel;
  className?: string;
}

const Name: FC<Props> = observer(({ item }) => {
  const {
    appStore: { isDesktop, screenClassNames },
  } = useStores();

  const {
    data: {
      advert: { url, isPriority, isSimpleAdvert },
    },
  } = useMiniCard();

  const showPriorityIcon = isPriority && (isSimpleAdvert || item.isFirstItem);

  return (
    <NameStyles>
      <NameLink
        href={url}
        onClick={(e: React.SyntheticEvent) => e.preventDefault()}
        className={screenClassNames}
      >
        <span className="text">
          {item.brand} {item.model}
        </span>
        {showPriorityIcon && <PriorityIcon className="priority-icon" />}
        {isDesktop && <NameOfType>{item.nameOfType}</NameOfType>}
      </NameLink>
    </NameStyles>
  );
});

export default Name;
